<template>
  <div class="p-6">
    <h1 class="text-2xl font-semibold mb-4">Paramètres - Comptabilité</h1>
    <div class="bg-white rounded-lg border border-gray-200 p-4">
      <p class="text-sm text-gray-600">Réglages relatifs à la comptabilité : plan comptable, paramètres TVA, clôtures et préférences.</p>

      <!-- Basic placeholders -->
      <div class="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Préfixe des numéros comptables</label>
          <input class="w-full border rounded px-3 py-2" v-model="prefix" type="text" placeholder="Ex: ACC-" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Monnaie par défaut</label>
          <select v-model="currency" class="w-full border rounded px-3 py-2">
            <option value="MGA">Ar</option>
            <option value="EUR">€</option>
            <option value="USD">$</option>
          </select>
        </div>
      </div>

      <div class="mt-4">
        <button class="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700">Enregistrer</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const prefix = ref('')
const currency = ref('MGA')
</script>

<style scoped></style>
